// extracted by mini-css-extract-plugin
module.exports = {"PageFooter":"PageFooter_PageFooter__33_40","Nav":"PageFooter_Nav__1k4ux","Social":"PageFooter_Social__lrYGK"};